import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioSafe } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useSelectAllScenarioSafes = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: selectAllSafes, isPending } = useAppMutation([QueryKey.CREATE_SCENARIO_SAFE], {
    mutationFn: ({
      scenarioId,
      data,
      onlySelected,
    }: {
      data: CreateScenarioSafe;
      onlySelected?: boolean;
      scenarioId: string;
    }) =>
      ApiService.post(
        { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'safe', 'convert-all'] },
        {
          body: data,
          queryParams: {
            onlySelected,
          },
        },
      ),
    onSuccess: () => {
      invalidateCalculationQueries();
    },
  });
  return { selectAllSafes, isPending };
};
